module.exports = __webpack_public_path__ + "firstPartLanding.jpg";